import { useTranslation } from 'react-i18next';

import { Heading } from '@ctct/presentation-layer';

import { SingleBillInfoFormWidgetContent } from './SingleBillInfoFormWidgetContent';
import type { SingleBillInfoFormWidgetProps } from './useSingleBillInfoFormWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const SingleBillInfoFormWidget = ({ status, data, handlers, hooks }: SingleBillInfoFormWidgetProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading>{t('single-bill-info-form.heading')}</Heading>
      <WithStatusHandling
        status={status}
        errorMessage={status === 'error' ? data.message : undefined}
        retry={status === 'error' ? handlers.retry : undefined}
        skeletonHeight={182}
      >
        {status === 'loaded' && <SingleBillInfoFormWidgetContent data={data} handlers={handlers} hooks={hooks} />}
      </WithStatusHandling>
    </>
  );
};
